<template>
  <div class="container" v-if="roadmap && selected">
    <div class="headline text-center my-4">
      {{roadmap.title}} guide
      <span class="font-weight-light">by {{roadmap.authors.join(', ')}}</span>
    </div>
    <v-stepper v-model="step" vertical>
      <v-stepper-step :complete="step > 1" step="1">
        Step 1
      </v-stepper-step>

      <v-stepper-content step="1">
        <plan-settings
                :roadmap="roadmap"
                :selected="selected"
                :onNextStep="planSelected"
        />
      </v-stepper-content>

      <v-stepper-step :complete="step > 2" step="2">
        Step 2
      </v-stepper-step>

      <v-stepper-content step="2">
        <plan-modifier
                :used="used"
                :unused="unused"
                :onNextStep="planModified"
                :onPrevStep="decreaseStep"
        />
      </v-stepper-content>

      <v-stepper-step :complete="step > 3" step="3">
        Step 3
      </v-stepper-step>

      <v-stepper-content step="3">
        <plan-viewer
                :plan="plan"
                :roadmap="roadmap"
                :onPrevStep="decreaseStep"
        />
      </v-stepper-content>
    </v-stepper>
  </div>
</template>

<script>
  import PlanSettings from "@/components/PlanCustomizer";
  import PlanModifier from "@/components/PlanModifier";
  import PlanViewer from "@/components/PlanViewer";

  export default {
    name: "PlanBuilder",
    components: {PlanViewer, PlanModifier, PlanSettings},
    data() {
      return {
        step: 1,

        selected: undefined,
        unused: [],
        used: [],
        plan: [],
      }
    },
    computed: {
      concepts() { return this.$store.state.concepts },
      roadmap() { return this.$store.getters.roadmap(this.$route.params.slug) }
    },
    watch: {
      roadmap(val) {
        if (this.selected === undefined) {
          this.selected = val.steps.map(() => []);
        }
      }
    },
    methods: {
      decreaseStep() {
        this.step -= 1;
      },
      increaseStep() {
        this.step += 1;
      },
      planSelected(plan) {
        // TODO in unused remove only old from selected
        this.used = plan.map((concept, idx) => {
          return { idx, concept };
        });
        this.unused = plan.map((_, idx) => {
          return { idx, concept: null };
        });

        this.increaseStep();
      },
      planModified(plan) {
        this.plan = plan;

        this.increaseStep();
      }
    },
    created() {
      if (this.roadmap !== undefined) {
        this.selected = this.roadmap.steps.map(() => []);
      }
    }
  }
</script>

<style scoped>
  .container {
    width: 70%;
    margin: auto;
  }
</style>
